'use strict';

var React = require('react');

var SvgSocialAdMajor = function SvgSocialAdMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20a1.5 1.5 0 0 0 1.5-1.5v-7.5a1 1 0 0 0-2 0v7h-13v-14h7a1 1 0 0 0 0-2h-7.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h14zm-.056-15.168a.999.999 0 0 0 1.263-.125l2-2a1 1 0 0 0-1.414-1.414l-2 2a1 1 0 0 0 .15 1.54zm1.556 3.168h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm-4.707-4.293a1 1 0 0 0 1.707-.707v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 .293.707zm-1.293 2.293h-7v6h9v-6h-2zm-7 8h9v2h-9v-2z"
  }));
};

exports.SvgSocialAdMajor = SvgSocialAdMajor;
